import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import Dropzone from 'react-dropzone'

import { Row, Col, Container, Card, Button, Spinner } from 'react-bootstrap';

import PermLinks from './perm-links';
import ValidateService from '../../service/validate-service';
import FileInfoService from '../../service/file-info-service';
import { ModalAlert } from '../template/modal-alert';

import SmoothScroll from 'smooth-scroll';

import i18n from "../../i18n";

import ReCAPTCHA from 'react-google-recaptcha';

export default class ValidateDoc extends Component {


	constructor(props) {
		super(props);

		this.state = {
			showPermLinks: false,
			showSignedFile: false,
			showOriginalFile: false,
			showLoadingBar: false,
			signedFile: null,
			signedFileBase64: null,
			signedFileName: null,
			originalFile: null,
			originalFileBase64: null,
			originalFileName: null,
			readDocumentCounter: 0,
			permLinks: [],
			documentName: null,
			showSignedAlert: false,
			showOriginalAlert: false,
			signedFileUniqueId: null,
			originalFileUniqueId: null,
			showCaptcha: document.getElementById("recaptcha").getAttribute("value"),
			recaptchaSiteKey: document.getElementById("recaptchaSiteKey").getAttribute("value")

		};

		this.handleValidate = this.handleValidate.bind(this);
		this.handleSignedFileSelection = this.handleSignedFileSelection.bind(this);
		this.handleOriginalFileSelection = this.handleOriginalFileSelection.bind(this);
		this.handleRemoveSignedFile = this.handleRemoveSignedFile.bind(this);
		this.handleRemoveOriginalFile = this.handleRemoveOriginalFile.bind(this);
		this.scrollToValidate = this.scrollToValidate.bind(this);
		this.handleRefreshPage = this.handleRefreshPage.bind(this);
		this.handleSignedAlertClose = this.handleSignedAlertClose.bind(this);
		this.handleOriginalAlertClose = this.handleOriginalAlertClose.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.readDocument = this.readDocument.bind(this);
		this.recaptchaRef = React.createRef();
	}

	handleSubmit(event) {
		event.preventDefault();

		if (this.state.showCaptcha == 1) {
			this.recaptchaRef.current.execute();
		} else {
			this.handleValidate();
		}

	}

	handleValidate() {
		let self = this;
		
		self.setState({
			readDocumentCounter: 0
		})

		if (this.state.signedFile != null) {
			document.getElementById("start_validating").hidden = true;
			self.setState({
				showLoadingBar: true
			})

			this.scrollToValidate();
		
			this.readDocument(this.state.signedFile[0], this.state.originalFile != null ? 2 : 1, true)
			
			if (this.state.originalFile != null) {
				this.readDocument(this.state.originalFile[0], 2, false)
				
			}

		} else {
			ModalAlert("Za nastavak validacije potrebno je učitati potpisanu datoteku.", i18n.t("modal:greska"), i18n.t("modal:zatvori"));
		}
	}

	readDocument(doc, numOfFiles, isSignatureFile) {	
			let self = this;
			//asinhrono čita dokument
			const reader = new FileReader();
			reader.onabort = () => {
				ModalAlert("Prekinuto čitanje datoteke", i18n.t("modal:greska"), i18n.t("modal:zatvori"));
				self.setState({
					showPermLinks: false,
					showLoadingBar: false,
					permLinks: []
				});
				self.handleRemoveSignedFile();
				self.handleRemoveOriginalFile();
			}
			reader.onerror = () => {
				ModalAlert("Greška pri čitanju datoteke", i18n.t("modal:greska"), i18n.t("modal:zatvori"));
				self.setState({
					showPermLinks: false,
					showLoadingBar: false,
					permLinks: []
				});
				self.handleRemoveSignedFile();
				self.handleRemoveOriginalFile();
			}
			reader.onload = (file) => {
				
				const base64 = reader.result;
				
				if(isSignatureFile){
					self.state.documentName = doc.name;
					self.setState({signedFileBase64: base64.substr(base64.indexOf(",") + 1),
						signedFileName: doc.name
					 })
				}else{
					self.setState({
						originalFileBase64: base64.substr(base64.indexOf(",") + 1),
						originalFileName: doc.name
					});
				}

				self.setState({
					readDocumentCounter: self.state.readDocumentCounter + 1
				})

				if (numOfFiles == self.state.readDocumentCounter) {
					self.setState({
						readDocumentCounter: 0
					})
					ValidateService.uploadFileToServer(self.state.signedFileBase64, self.state.signedFileName, self.state.originalFileBase64, self.state.originalFileName , self.state.signedFileUniqueId, self.state.originalFileUniqueId, (self.state.showCaptcha == 1 ? self.recaptchaRef.current.getValue() : null)).then(response => {
						self.setState({
							permLinks: response.data.validationResponseList,
							signedFileUniqueId: response.data.signedFileUniqueId,
							originalFileUniqueId: response.data.originalFileUniqueId,
							showPermLinks: true,
							showLoadingBar: false
						});
					}
					).catch(error => {
						if (error.response == null) {
							ModalAlert(error.message, i18n.t("modal:greska"), i18n.t("modal:zatvori"));
						} else {
							ModalAlert(error.response.data.error.errorMsg, i18n.t("modal:greska"), i18n.t("modal:zatvori"));
						}
						self.setState({
							showPermLinks: false,
							showLoadingBar: false,
							permLinks: []
						});
						self.handleRemoveSignedFile();
						self.handleRemoveOriginalFile();
					});
				}
		}
		reader.readAsDataURL(doc);
	}

	scrollToValidate() {
		var scroll = new SmoothScroll('a[href*="#"]', {
			offset: 50
		});

		var anchor = document.getElementById("validate");
		scroll.animateScroll(anchor);

	}

	handleSignedFileSelection(acceptedFile) {
		FileInfoService.recordFileInfo(1, acceptedFile[0].size, acceptedFile[0].type, acceptedFile[0].name).then(response => {
			this.setState({
				signedFileUniqueId: response.data.signedFileUniqueId
			});
		}).catch(error => {
			ModalAlert(error.response.data.error.errorMsg, i18n.t("modal:greska"), i18n.t("modal:zatvori"));
			this.setState({
				showPermLinks: false,
				showLoadingBar: false,
				permLinks: []
			});
			this.handleRemoveSignedFile();
			this.handleRemoveOriginalFile();
		});
		if (acceptedFile[0].size > document.getElementById("maxFileSize").getAttribute("value")) {
			this.setState({ signedFile: null, showSignedFile: false, showSignedAlert: true });
		} else {
			this.setState({ signedFile: acceptedFile, showSignedFile: true, showSignedAlert: false });
		}

	}

	handleOriginalFileSelection(acceptedFile) {
		this.setState({
			error: null
		});
		FileInfoService.recordFileInfo(2, acceptedFile[0].size, acceptedFile[0].type, acceptedFile[0].name).then(response => {
			this.setState({
				originalFileUniqueId: response.data.originalFileUniqueId
			});
		}).catch(error => {
			ModalAlert(error.response.data.error.errorMsg, i18n.t("modal:greska"), i18n.t("modal:zatvori"));
			this.setState({
				showPermLinks: false,
				showLoadingBar: false,
				permLinks: []
			});
			this.handleRemoveSignedFile();
			this.handleRemoveOriginalFile();
		});
		if (acceptedFile[0].size > document.getElementById("maxFileSize").getAttribute("value")) {
			this.setState({ originalFile: null, showOriginalFile: false, showOriginalAlert: true });
		} else {
			this.setState({ originalFile: acceptedFile, showOriginalFile: true, showOriginalAlert: false });
		}

	}

	handleRemoveSignedFile() {
		this.setState({
			signedFileUniqueId: null,
			showSignedFile: false,
			signedFile: null,
			signedFileBase64: null,
			signedFileName: null,
		})
	}

	handleRemoveOriginalFile() {
		this.setState({
			originalFileUniqueId: null,
			showOriginalFile: false,
			originalFile: null,
			originalFileBase64: null,
			originalFileName: null
		})
	}

	handleSignedAlertClose() {
		this.setState({ showSignedAlert: false })
	}

	handleOriginalAlertClose() {
		this.setState({ showOriginalAlert: false })
	}

	handleRefreshPage() {
		window.location.reload();
	}

	render() {
		return (
			<div id="validateDoc">
				<Container>
					{!this.state.showPermLinks ?
						<form className="justify-content-center" onSubmit={this.handleSubmit}>
							{this.state.showSignedAlert ?
								<div className="alert alert-danger" role="alert" aria-atomic="true">
									<Row>
										<Col className="col-11 col-sm-11">
											{i18n.t("home:big_file")}
										</Col>
										<Col className="col-1 col-sm-1">
											<button onClick={this.handleSignedAlertClose} type="button" style={{ "padding": "0px" }} className="btn float-right">
												<i className="material-icons">clear</i>
											</button>
										</Col>
									</Row>
								</div>
								:
								null
							}

							<Dropzone multiple={false} onDrop={acceptedFile => this.handleSignedFileSelection(acceptedFile)}>
								{({ getRootProps, getInputProps }) => (
									<div {...getRootProps()} role="button">
										<input {...getInputProps()} tabIndex="-1" />

										<Card style={{ cursor: "pointer" }} className="text-center">
											<Card.Body>
												<Card.Title>{i18n.t("home:signed_document")}</Card.Title>
												<i className="material-icons" aria-hidden="true">cloud_upload</i>
												<Card.Text className="text-left">
													{i18n.t("home:upload_signed_text")}
												</Card.Text>
											</Card.Body>
										</Card>
									</div>
								)}
							</Dropzone>

							{this.state.showSignedFile ?
								<>
									<Card.Footer style={{ wordBreak: "break-word" }} className="text-center">
										{this.state.signedFile[0].name}
										<button onClick={this.handleRemoveSignedFile} type="button" className="btn">
											<i className="material-icons">clear</i>
										</button>
									</Card.Footer>
								</>
								: null
							}

							<br />

							{this.state.showOriginalAlert ?
								<div className="alert alert-danger" role="alert" aria-atomic="true">
									<Row>
										<Col className="col-11 col-sm-11">
											{i18n.t("home:big_file")}
										</Col>
										<Col className="col-1 col-sm-1">
											<button onClick={this.handleOriginalAlertClose} type="button" style={{ "padding": "0px" }} className="btn float-right">
												<i className="material-icons">clear</i>
											</button>
										</Col>
									</Row>
								</div>
								:
								null
							}
							<Dropzone multiple={false} onDrop={acceptedFile => this.handleOriginalFileSelection(acceptedFile)}>
								{({ getRootProps, getInputProps }) => (
									<div {...getRootProps()} role="button">
										<input {...getInputProps()} tabIndex="-1" />

										<Card style={{ cursor: "pointer" }} className="text-center">
											<Card.Body>
												<Card.Title>{i18n.t("home:original_document")}<sup>[1]</sup></Card.Title>
												<i className="material-icons" aria-hidden="true">cloud_upload</i>
												<Card.Text className="text-left">
													{i18n.t("home:upload_original_text")}
												</Card.Text>
												<Card.Text className="text-left" style={{ "fontSize": "0.9rem", "textAlign": "left" }}>
													{i18n.t("home:upload_original_text_extra")}
												</Card.Text>
											</Card.Body>
										</Card>
									</div>
								)}
							</Dropzone>
							{this.state.showOriginalFile ?
								<>
									<Card.Footer style={{ wordBreak: "break-word" }} className="text-center">
										{this.state.originalFile[0].name}
										<button onClick={this.handleRemoveOriginalFile} type="button" className="btn">
											<i className="material-icons">clear</i>
										</button>
									</Card.Footer>
								</>
								: null
							}

							<br />
							<Row>
								<Col lg={12} sm={12}>
									<br />
									{!this.state.showLoadingBar ?
										<div className="justify-content-end d-flex" >
											<Button
												style={{ backgroundColor: "#3f5c94" }}
												id="validateBtn"
												type="submit">
												{i18n.t("home:validate_button")}
											</Button>
										</div>
										:
										<div className="justify-content-end d-flex" >
											<Button
												style={{ backgroundColor: "#3f5c94" }}
												disabled>
												<Spinner
													style={{ marginRight: "3px" }}
													as="span"
													animation="grow"
													size="sm"
													role="status"
													aria-hidden="true"
												/>
												{i18n.t("home:validating")}
											</Button>
										</div>
									}

								</Col>
							</Row>

							{this.state.showCaptcha == 1 ?
								<ReCAPTCHA style={{ zIndex: "100000" }}
									ref={this.recaptchaRef}
									sitekey={this.state.recaptchaSiteKey}
									onChange={this.handleValidate}
									size="invisible"
								/>
								: null
							}

						</form>
						: null
					}

					{this.state.showPermLinks ?
						<div>
							<PermLinks permLinks={this.state.permLinks} documentName={this.state.documentName} />
							<br />
							<div className="justify-content-end d-flex">
								<Button style={{ backgroundColor: "#3f5c94" }} onClick={this.handleRefreshPage} >{i18n.t("home:validate_new")}</Button>
							</div>
							<br />

							<div>
								<p>{i18n.t("home:copy_info")} <i className="align-middle material-icons">content_copy</i>.</p>
							</div>
						</div>
						: null
					}

				</Container>
			</div>
		)
	}
}